import { Make } from '../../models/Make'

const mutations = {
  setCurrentMake(state: any, make: Make) {
    state.currentMake = make
  },
  clearCurrentMake(state: any) {
    state.currentMake = null
  }
}

const getters = {
  currentMake(state: any) {
    return state.currentMake
  },
}

const actions = {
  async loadMake(context : any, args: any) {
    const make : Make | null = await Make.getMake(args.makeId)
    if (make != null) {
      context.commit('setCurrentMake', make)
    }

    return Promise.resolve()
  }
}

const state = () => ({
  currentMake: Make
})

export default {
    namespaced: true,
    mutations,
    getters,
    state,
    actions,
}
